/*
  Pinned header that gets out of the way.

  Once the theme pins the navigation (.navigation--sticky), scrolling down
  slides it out of view and scrolling up brings it back, so it never sits over
  the content being read. It stays in view while a pointer or keyboard focus
  is inside it, so an open dropdown is never pulled away.
*/
(function () {
  const HIDDEN_CLASS = 'navigation--tucked';
  const STICKY_CLASS = 'navigation--sticky';
  const MIN_DELTA = 6;

  function setUp(nav) {
    if (nav.hasAttribute('data-headroom')) return;
    nav.setAttribute('data-headroom', '');

    let lastY = window.scrollY;
    let wasSticky = nav.classList.contains(STICKY_CLASS);
    let queued = false;

    function engaged() {
      return nav.matches(':hover') || nav.contains(document.activeElement);
    }

    function hideWithoutSliding() {
      nav.style.transition = 'none';
      nav.classList.add(HIDDEN_CLASS);
      nav.offsetHeight;
      nav.style.transition = '';
    }

    function update() {
      queued = false;
      const maxY = document.documentElement.scrollHeight - window.innerHeight;
      const y = Math.min(Math.max(window.scrollY, 0), Math.max(maxY, 0));
      const sticky = nav.classList.contains(STICKY_CLASS);
      const delta = y - lastY;

      if (!sticky) {
        nav.classList.remove(HIDDEN_CLASS);
      } else if (!wasSticky && delta > 0 && !engaged()) {
        hideWithoutSliding();
      } else if (Math.abs(delta) >= MIN_DELTA) {
        if (delta > 0 && !engaged()) {
          nav.classList.add(HIDDEN_CLASS);
        } else if (delta < 0) {
          nav.classList.remove(HIDDEN_CLASS);
        }
      } else {
        return;
      }

      lastY = y;
      wasSticky = sticky;
    }

    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    nav.addEventListener('focusin', function () {
      nav.classList.remove(HIDDEN_CLASS);
    });
  }

  function init() {
    document.querySelectorAll('.js-navigation').forEach(setUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
